module.exports = __webpack_public_path__ + "static/Vultus-b47535c897867b2bb2a7c5ba2c0a92cc.jpg";